<div class="card" style="padding-bottom: 100px;">
  <iframe id="video" style="margin: auto" [src]="safeUrl" width="800" height="400" frameborder="0"></iframe>
</div>
